// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"TrackingTooltip_tooltip__70KJr","content":"TrackingTooltip_content__25qFe"};